import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IntegrationSettings } from "../settings/settings.interface";

@Injectable({
  providedIn: "root",
})
export class IntegrationSettingsService {
  constructor(private http: HttpClient) {}

  get(): Observable<IntegrationSettings> {
    return this.http.get<IntegrationSettings>("/settings");
  }

  update(settings: IntegrationSettings): Observable<IntegrationSettings> {
    return this.http.post<IntegrationSettings>("/settings", settings);
  }

  checkSpfRecord(): Observable<{ valid: boolean }> {
    return this.http.get<{ valid: boolean }>(`/settings/spf-check`);
  }

  getCalamariConfig(): Observable<{
    success: boolean;
    config?: {
      apiKey: string;
      tenant: string;
      absenceEnabled: boolean;
      absenceLabel: string | null;
      absenceDaysAhead: number;
      substituteText: string | null;
    };
  }> {
    return this.http.get<{
      success: boolean;
      config?: {
        apiKey: string;
        tenant: string;
        absenceEnabled: boolean;
        absenceLabel: string | null;
        absenceDaysAhead: number;
        substituteText: string | null;
      };
    }>("/calamari/config");
  }

  saveCalamariConfig(config: unknown): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>("/calamari/config", config);
  }

  syncCalamari(): Observable<{
    success: boolean;
    calamariSyncStateId?: string;
  }> {
    return this.http.post<{ success: boolean; calamariSyncStateId?: string }>(
      "/calamari/sync",
      {},
    );
  }

  overrideEmployeesFromCalamari(): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      "/calamari/override-employees",
      {},
    );
  }

  notifyAdmin(
    provider: "google" | "microsoft",
    adminEmail: string,
    subject: string,
    message: string,
  ): Observable<unknown> {
    return this.http.post<unknown>("/settings/notify-admin", {
      provider,
      adminEmail,
      subject,
      message,
    });
  }
}
